var map = {
	"./ascendex.svg": "c581",
	"./biconomy.svg": "a608",
	"./big1.svg": "ba04",
	"./bitmart.svg": "3ba8",
	"./bkex.svg": "efbc",
	"./coinsbit.svg": "3281",
	"./coinw.svg": "92e0",
	"./digifinex.svg": "2cc0",
	"./mexc.svg": "dd92",
	"./xt.svg": "164f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e818";